export default "__VITE_ASSET__rHhrS3ja__"